"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEnabled = isEnabled;
exports.getUrl = getUrl;
exports.getSwitchUrl = getSwitchUrl;
exports.getSwitchUrlCountries = getSwitchUrlCountries;
exports.getCountryCode = getCountryCode;
exports.injectAccessors = void 0;

/* eslint-disable no-console */
var partial = function partial(func) {
  for (var _len = arguments.length, defaultArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    defaultArgs[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return func.apply(void 0, defaultArgs.concat(args));
  };
};

function isEnabled(config, name) {
  if (typeof config.enable[name] === 'undefined') {
    console.log("Missing enable flag ".concat(name));
  }

  if (typeof config.enable[name] === 'undefined') {
    return false;
  }

  return config.enable[name];
}

function getUrl(config, name) {
  return config.url[name];
}

function getSwitchUrl(config) {
  return config.domain && config.domain.switchUrl ? config.domain.switchUrl : null;
}

function getSwitchUrlCountries(config) {
  var switchUrl = getSwitchUrl(config);
  return switchUrl && switchUrl.countries ? switchUrl.countries : null;
}

function getCountryCode(config) {
  return config.countryCode;
}

var injectAccessors = function injectAccessors(config) {
  return Object.assign(config, {
    isEnabled: partial(isEnabled, config),
    getUrl: partial(getUrl, config),
    getSwitchUrl: partial(getSwitchUrl, config),
    getCountryCode: partial(getCountryCode, config)
  });
};

exports.injectAccessors = injectAccessors;